// extracted by mini-css-extract-plugin
export var button = "buttonPrint-module--button--0f7f6";
export var content = "buttonPrint-module--content--05203";
export var text = "buttonPrint-module--text--03641";
export var wrapper = "buttonPrint-module--wrapper--ae3c8";